import React, { useEffect, useState } from 'react'
import CustomSelect from '../../ui/CustomSelect'
import { Input, Select, message } from 'antd'
import SortIcon from '../../../assets/sort.svg';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import OtpTemplate from '../../../assets/templates/otptemplate.png';
import Loader from '../../shared/Loader';
import { GetTemplates } from '../../../utils/api';

const EmailTemplates = () => {
    const { Search } = Input;
    const [page, setpage] = useState(0);
    const [count, setCount] = useState(10);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const handleSortChange = () => {

    }

    const [loading, setLoading] = useState(false);
    const [templates, setTemplates] = useState([]);

    const getTemplates = async () => {
        let params = 'type=email';
        try {
            setLoading(true);
            const response = await GetTemplates(params);
            if (response?.isSuccess) {
                setTemplates(response?.items);
            }
        } catch (error) {
            message.error('Error while getting data, Try again later');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getTemplates();
    }, []);

    if (loading) {
        return <Loader />
    }

    return (
        // <div className='w-full absolute -top-[90px] h-full'>
        <div className='w-full h-full'>
            {/* <div className='flex items-center gap-x-4 mb-14'>
                <div className='ml-6 custom-sortby z-50 left-[284px] top-[19px]'>
                    <CustomSelect prefixIcon={SortIcon} placeholder='Sort by' onChange={(val) => handleSortChange(val)}>
                        <Select.Option value='all'>All</Select.Option>
                        <Select.Option value='push'>Push</Select.Option>
                        <Select.Option value='email'>Email</Select.Option>
                    </CustomSelect>
                </div>
            </div> */}

            <section className='templets-card p-6 poppins'>
                {/* <div className='grid grid-cols-3 gap-6' >
                    <div className='box-shadow p-4 flex flex-col gap-y-2 rounded-2xl'>
                        <div className='flex flex-col gap-y-3'>
                            <p className='text-base font-bold text-center h-10'>Welcome and Account Activation (Email)</p>
                            <div>
                                <img className='w-32 mx-auto rounded-lg' src={WelcomeImg} alt="template-img" />
                            </div>
                        </div>
                        <div className='px-2 pt-2'>
                            <div className='flex gap-x-3'>
                                <span className='text-sm font-semibold underline'>Subject:</span>
                                <p className='text-sm leading-tight mb-2 h-14'>Welcome to Beauty Spot - Your Beauty Journey Begins</p>
                            </div>
                            <div className='w-full'>
                                <p className='text-xs'>Welcome to Beauty Spot, your personalized beauty destination! We are thrilled to have you join our community of beauty enthusiasts and professionals.
                                    <br />
                                    To get started, simply click on the link below to activate your account and unlock a world of beauty inspiration, tips, and services.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='box-shadow p-4 flex flex-col gap-y-2 rounded-2xl'>
                        <div className='flex flex-col gap-y-3'>
                            <p className='text-base font-bold text-center h-10'>Exclusive Beauty Offers (Email)</p>
                            <div>
                                <img className='w-32 mx-auto rounded-lg' src={OffersImg} alt="template-img" />
                            </div>
                        </div>
                        <div className='px-2 pt-2'>
                            <div className='flex gap-x-3'>
                                <span className='text-sm font-semibold underline'>Subject:</span>
                                <p className='text-sm leading-tight mb-2 h-14'>Exclusive Beauty Offers Await You on Beauty Spot</p>
                            </div>
                            <div className='w-full'>
                                <p className='text-xs'>As a valued member of Beauty Spot, we're excited to offer you exclusive beauty offers that are tailored just for you. Discover incredible deals on a variety of beauty services and products that match your preferences.
                                    <br />
                                    Don't miss out on these limited-time opportunities to enhance your beauty experience. Thank you for being a part of our beauty community!
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='box-shadow p-4 flex flex-col gap-y-2 rounded-2xl'>
                        <div className='flex flex-col gap-y-3'>
                            <p className='text-base font-bold text-center h-10'>Personalized Beauty Recommendations (Email)</p>
                            <div>
                                <img className='w-32 mx-auto rounded-lg' src={TurnoverImg} alt="template-img" />
                            </div>
                        </div>
                        <div className='px-2 pt-2'>
                            <div className='flex gap-x-3'>
                                <span className='text-sm font-semibold underline'>Subject:</span>
                                <p className='text-sm leading-tight mb-2 h-14'>Your Personalized Beauty Recommendations Are Here</p>
                            </div>
                            <div className='w-full'>
                                <p className='text-xs'>We're excited to introduce you to personalized beauty recommendations, designed to enhance your beauty routine. Based on your unique preferences and needs, we've curated a selection of beauty products and services that align with your style.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='box-shadow p-4 flex flex-col gap-y-2 rounded-2xl'>
                        <div className='flex flex-col gap-y-3'>
                            <p className='text-base font-bold text-center h-10'>Product Spotlight (Push)</p>
                            <div>
                                <img className='w-32 mx-auto rounded-lg' src={TurnoverImg} alt="template-img" />
                            </div>
                        </div>
                        <div className='px-2 pt-2'>
                            <div className='flex gap-x-3'>
                                <span className='text-sm font-semibold underline'>Title:</span>
                                <p className='text-sm leading-tight mb-2 h-14'>New Arrival Alert: [Product Name] is Here!</p>
                            </div>
                            <div className='w-full'>
                                <p className='text-xs'>Introducing [Product Name] - the must-have beauty product of the season. Discover its magic and elevate your beauty regimen.

                                </p>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div className='grid grid-cols-3 2xl:grid-cols-4 gap-6'>
                    {
                        templates && templates.length > 0 &&
                        templates.map((template) => {
                            return (
                                <img key={template.id} src={template.body} className='w-full box-shadow rounded-lg' alt={template?.title} />
                            )
                        })
                    }
                </div>
            </section>

            {/* Footer */}
            {/* <div className="box-shadow-pagination text-sm poppins" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 20px', marginTop: '20px' }}>
                <div className='bottom-pagination-text'>
                    <button className='disabled:opacity-50' onClick={(e) => { }} disabled={page === 0}><LeftOutlined /></button>
                    <span style={{ margin: '0 10px' }}>{page + 1} of {Math.ceil(count / rowsPerPage)}</span>
                    <button className='disabled:opacity-50' onClick={(e) => { }} disabled={page === Math.ceil(count / rowsPerPage) - 1}><RightOutlined /></button>
                </div>
                <div style={{ position: 'absolute', right: '25px' }} >
                    <span style={{ margin: '0 10px' }}>Items per page:</span>
                    <select className='pagination-select' value={rowsPerPage} onChange={(e) => {
                        setItemsPerPage(e.target.value);

                    }}>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                        <option value={20}>20</option>
                    </select>
                </div>
            </div> */}
        </div>
    )
}

export default EmailTemplates;